// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"2a3115f1","296":"8868d212","589":"9ee468d6","750":"cf5f876f","954":"da83d586"}[chunkId] + ".chunk.js";
};